<template>
    <div>
        <div class="modal" :class="{ 'is-active': isActive }">
            <div class="modal-background"></div>
            <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Confirmation</p>
                <button class="delete" @click="closeModal" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <p v-if="!actionExecuted">{{ message }}</p>
                <p v-else :class="resultClass">{{ resultMessage }}</p>
            </section>
            <footer class="modal-card-foot" v-if="!actionExecuted">
                <button class="button is-success" :disabled="waitingResponse" @click="confirmAction">
                <span v-if="waitingResponse" class="loader" style="margin-right: 5px;"></span>
                <span v-if="!waitingResponse">Confirmer</span>
                </button>
                <button class="button" :disabled="waitingResponse" @click="closeModal">Annuler</button>
            </footer>
            </div>
        </div>
    </div>
</template>

<script>
export default {
props: {
    isActive: {
        type: Boolean,
        required: true
    },
    message: {
        type: String,
        required: true
    }
},
data() {
    return {
    actionExecuted: false,
    resultMessage: '',
    resultClass: '',
    waitingResponse: false
    };
},
methods: {
    closeModal() {
    this.$emit('close');
    this.resetModal();
    },
    confirmAction() {
    this.waitingResponse = true
    this.$emit('confirm')
    },
    handleResult(result) {
    this.waitingResponse = false
    this.actionExecuted = true
    if (result.success) {
        this.resultMessage = 'Opération réussie';
        this.resultClass = 'has-text-success';
    } else {
        this.resultMessage = "Echec de l'opération";
        this.resultClass = 'has-text-danger';
    }
    setTimeout(() => {
        this.closeModal();
    }, 2500);
    },
    resetModal() {
    this.actionExecuted = false;
    this.resultMessage = '';
    this.resultClass = '';
    }
},
watch: {
    isActive(newVal) {
    if (!newVal) {
        this.resetModal();
    }
    }
}
};
</script>

<style scoped>
.modal-card {
width: 400px;
}
</style>
